import React from 'react';
import { Col } from 'antd';
import { WrittenWorkProcedureFormItem } from '@/components/views/Resolution886/components/Form';

export function WrittenWorkProcedure(): JSX.Element {
	return (
		<Col xs={24}>
			<WrittenWorkProcedureFormItem fieldName="written_work_procedure" required={false} />
		</Col>
	);
}
